module.exports = __webpack_public_path__ + "img/not-content.249c1d26.png";